import schema from './__generated__/schema.possibleTypes.json';
export const possibleTypes = schema.possibleTypes;
